//用于新增用户
import { ModalForm, ProFormText } from '@ant-design/pro-components';
import { FormattedMessage, useIntl } from '@@/exports';
import { Form } from 'antd';
import React from 'react';

// 定义子组件的 Props 类型
interface UpdatingUserPasswordFormProps {
  updatingModalOpen: boolean;
  handleModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleUpdating: (fields: any) => Promise<boolean>;
}

export const UpdatingUserPasswordForm: React.FC<UpdatingUserPasswordFormProps> = ({
  updatingModalOpen,
  handleModalOpen,
  handleUpdating,
}) => {
  //表单绑定组件
  const [form] = Form.useForm();
  // 国际化组件
  const intl = useIntl();

  return (
    <ModalForm
      form={form}
      title={intl.formatMessage({
        id: 'pages.userTable.createUser',
        defaultMessage: 'Create user',
      })}
      width="400px"
      open={updatingModalOpen}
      onOpenChange={handleModalOpen}
      onFinish={async (value) => {
        const success = await handleUpdating(value);
        if (success) {
          form.resetFields();
          handleModalOpen(false);
        }
      }}
    >
      {/*用户名*/}
      {/*密码*/}
      <ProFormText.Password
        name="password"
        label={intl.formatMessage({
          id: 'pages.setting.password',
        })}
        rules={[
          {
            required: true,
            min: 6,
            message: (
              <FormattedMessage
                id="pages.setting.reset.password.required"
                defaultMessage="A minimum of six digits password."
              />
            ),
          },
        ]}
      />

      {/* 确认密码输入框 */}
      <ProFormText.Password
        name="confirmPassword"
        label={intl.formatMessage({
          id: 'pages.setting.password.confirm',
        })}
        placeholder={intl.formatMessage({
          id: 'pages.setting.password.confirm.placeholder',
        })}
        dependencies={['password']} // 添加依赖，使得密码变化时重新触发校验
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: 'pages.setting.password.two',
              defaultMessage: 'Please confirm your password',
            }),
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error(
                  intl.formatMessage({
                    id: 'pages.setting.password.two',
                    defaultMessage: 'Please confirm your password',
                  }),
                ),
              );
            },
          }),
        ]}
      />
    </ModalForm>
  );
};
